/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiActionFieldModel;
(function (ApiActionFieldModel) {
    ApiActionFieldModel["ACTION_FIELD_MODEL_UNSPECIFIED"] = "ACTION_FIELD_MODEL_UNSPECIFIED";
    ApiActionFieldModel["CONTACT"] = "CONTACT";
})(ApiActionFieldModel || (ApiActionFieldModel = {}));
export function ApiActionFieldModelFromJSON(json) {
    return ApiActionFieldModelFromJSONTyped(json, false);
}
export function ApiActionFieldModelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiActionFieldModelToJSON(value) {
    return value;
}
